import React from "react";

import css from "./ViewedNoticeCounter.module.scss";

type Props = {
  suppliersCount: number;
};

export default function ViewedNoticeCounter({ suppliersCount }: Props) {
  return (
    <div>
      <p className={css.counter}>{suppliersCount} Suppliers have already viewed this notice</p>
    </div>
  );
}
